export default {
	round: [1, 2],
	otherRound: [2, 1],

	overviewRouteTitle: ['Počet kandidátů, kteří postupují do 2. kola', 'Počet nových senátorů'],
	overviewListTitle: ['Výsledky kandidátů v 1. kole', 'Výsledky kandidátů v 2. kole'],
	overviewShowMore: ['Všichni kandidáti', 'Všichni senátoři'],
	overviewShowLess: ['Méně kandidátů', 'Méně senátorů'],

	districtRouteTitle: ['Výsledky po 1. kole', 'Kolik získali kandidáti hlasů ve 2. kole'],
	districtRouteTitleProvisional: ['Do 2. kola zatím postupují', 'Kolik získali kandidáti hlasů ve 2. kole']
}
